import VConsole from 'vconsole';

// 本地 vite 开发不启用；构建产物中仍可通过 VITE_ENABLE_VCONSOLE 打开
if (!import.meta.env.DEV && import.meta.env.VITE_ENABLE_VCONSOLE === 'true') {
  new VConsole();
}
